import { render, staticRenderFns } from "./BchProductServiceGridRow.vue?vue&type=template&id=9eebfbe2&scoped=true"
import script from "./BchProductServiceGridRow.vue?vue&type=script&lang=js"
export * from "./BchProductServiceGridRow.vue?vue&type=script&lang=js"
import style0 from "./BchProductServiceGridRow.vue?vue&type=style&index=0&id=9eebfbe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eebfbe2",
  null
  
)

export default component.exports